import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
	toasts: any[] = [];
	showToast = false;

	public toastSubject = new BehaviorSubject<any>({});
	toastState$ = this.toastSubject.asObservable();

	show(message: string, title: string = '') {
		this.toasts.push({ message, title });
		this.toastSubject.next(this.toasts);
	}

	remove(toast: any) {
		this.toasts = this.toasts.filter((t) => t !== toast);
		this.toastSubject.next(this.toasts);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
		this.toastSubject.next(this.toasts);
	}

	constructor() {}

	// show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
	// 	this.toasts.push({ textOrTpl, ...options });
	// }

	// remove(toast: any) {
	// 	this.toasts = this.toasts.filter((t) => t !== toast);
	// }

	// clear() {
	// 	this.toasts.splice(0, this.toasts.length);
	// }
}
